module.exports = __webpack_public_path__ + "img/SaaS.581f5863.png";